import { render, staticRenderFns } from "./Carton.vue?vue&type=template&id=36827146"
import script from "./Carton.vue?vue&type=script&lang=js"
export * from "./Carton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports